/*
 * @Author: fz
 * @Date: 2021-07-12 11:15:50
 * @LastEditTime: 2021-07-23 09:11:42
 * @LastEditors: Please set LastEditors
 * @Description: 导出中心模块api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\exportCenter.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_EXPORT_WEB = "" } = e6ModuleBaseDataApi;

//获取导出文件列表数据
export function getExportsList(data) {
  return http({
    url: `${host}${E6_MS_TMS_EXPORT_WEB}/events/page`,
    method: "post",
    data
  });
}

//重新生成
export function RegenerateList(params) {
  return http({
    url: `${host}${E6_MS_TMS_EXPORT_WEB}/events/retry`,
    method: "post",
    params
  });
}

// 大数量导出 走导入中心
export function largeNumberExport(data) {
  return http({
    url: `${host}${E6_MS_TMS_EXPORT_WEB}/exportCenter/batchExport`,
    method: "post",
    data
  });
}
